export default "__VITE_ASSET__BLfZG3A2__"